import { useContext } from "react";
import { CardContext } from "../contexts/cardContext";

export function useCards() {
  const context = useContext(CardContext);

  return context;
}
